import React, { useEffect } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Loader2Icon } from 'lucide-react';
import { AdminDataProvider, useAdminData } from './contexts/AdminDataContext';
import { AdminShell } from './components/admin/AdminShell';
import { PublicSite } from './pages/PublicSite';
import { AdminLogin } from './pages/admin/AdminLogin';
import { Overview } from './pages/admin/Overview';
import { Enquiries } from './pages/admin/Enquiries';
import { Cases } from './pages/admin/Cases';
import { CaseNew } from './pages/admin/CaseNew';
import { CaseDetail } from './pages/admin/CaseDetail';
import { Customers } from './pages/admin/Customers';
import { CustomerDetail } from './pages/admin/CustomerDetail';
import { Settings } from './pages/admin/Settings';
import { company } from './data/site';
import { applyBrandIcon } from './utils/favicon';
import { initAnalytics } from './utils/analytics';
function RequireAdmin({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    loggedIn,
    authLoading
  } = useAdminData();
  if (authLoading) {
    return <div className="flex min-h-screen w-full items-center justify-center bg-canvas" data-id="element-0" data-mp="3mlj6wpc9h30f">
        <p className="flex items-center gap-2 text-[15px] text-ink-muted" data-id="element-1" data-mp="3mj6jhwnqi0fz">
          <Loader2Icon className="h-4 w-4 animate-spin" aria-hidden="true" data-id="element-2" data-mp="3rd19tixuhdo1" />
          Henter …
        </p>
      </div>;
  }
  if (!loggedIn) return <Navigate to="/admin/login" replace data-id="element-3" data-mp="2zlle8zeb8glo" />;
  return <>{children}</>;
}
export function App() {
  useEffect(() => {
    applyBrandIcon(company.logoMark, 'Lykkeværk');
    void initAnalytics();
  }, []);
  return <AdminDataProvider data-id="element-4" data-mp="38li8dgjgy7o4">
      <BrowserRouter data-id="element-5" data-mp="38l00tnrcw70w">
        <Routes data-id="element-6" data-mp="38nuodo5o27yj">
          <Route path="/" element={<PublicSite data-id="element-8" data-mp="3dle3sre3oqs2" />} data-id="element-7" data-mp="3dkuufz2inapn" />
          <Route path="/admin/login" element={<AdminLogin data-id="element-10" data-mp="3dii4aymltu1i" />} data-id="element-9" data-mp="3dlnsmbnesrw6" />
          <Route path="/admin" element={<RequireAdmin data-id="element-12" data-mp="nxwxflgnzkvp">
                <AdminShell data-id="element-13" data-mp="su45bjsmf6ga" />
              </RequireAdmin>} data-id="element-11" data-mp="nw2bc3tnpmq1">
            <Route index element={<Overview data-id="element-15" data-mp="35ynugqx9fzv" />} data-id="element-14" data-mp="36hv93iy4lzn" />
            <Route path="henvendelser" element={<Enquiries data-id="element-17" data-mp="38b5stwojqcx" />} data-id="element-16" data-mp="356s95xbri9l" />
            <Route path="sager" element={<Cases data-id="element-19" data-mp="3ubzt28o7hfdl" />} data-id="element-18" data-mp="3udawu8hnin4p" />
            <Route path="sager/ny" element={<CaseNew data-id="element-21" data-mp="d4o0nv3yoa99" />} data-id="element-20" data-mp="3ucjehzd2elwd" />
            <Route path="sager/:caseId" element={<CaseDetail data-id="element-23" data-mp="d3wcv6glvgtj" />} data-id="element-22" data-mp="d4xpvgh6mddw" />
            <Route path="kunder" element={<Customers data-id="element-25" data-mp="85bdf996h165" />} data-id="element-24" data-mp="85l1usekr09q" />
            <Route path="kunder/:customerId" element={<CustomerDetail data-id="element-27" data-mp="3glea6jyr55fp" />} data-id="element-26" data-mp="8648hcyry28g" />
            <Route path="indstillinger" element={<Settings data-id="element-29" data-mp="3glo2ie79rook" />} data-id="element-28" data-mp="3gmfvride9abo" />
          </Route>
          <Route path="*" element={<Navigate to="/" replace data-id="element-31" data-mp="3bnct24kvzg6v" />} data-id="element-30" data-mp="3bmthd5ltxo1a" />
        </Routes>
      </BrowserRouter>
    </AdminDataProvider>;
}